import ImageWithFallback from "components/ImageWithFallback"
import React from "react"
import {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import {Card} from "semantic-ui-react"
import MediaQuery from "react-responsive"
import { Col, Row } from "elemental-react16"
import Responsive           from "react-responsive"

export default class CategoryCard extends Component {

	render() {
		const {category, hasParents, className = "", fakeParent, title = true, fallback = "//placehold.it/420x240/f5f5f5/&text=X"} = this.props
		
		if ( !hasParents && !fakeParent ) {
			return	<Fragment>
				<MediaQuery maxWidth={767}>
				<Card className={`CategoryCard mobileVersion ${className}`} as={Link} to={`/collection/${category.map_id}`}
							style={{   backgroundImage: `url(/shop/rest/data/images/description/cat${category.map_id}/1?size=medium)`, backgroundSize: "cover", backgroundPosition: "center", minWidth: "450px", minHeight: "250px"}}>
								
								<div className={" white db pa3 mt4 f4 b hover-white underline-hover transition LinkBackgroundStyle"} style={{borderRadius: "15px"}}>{category.desc.short_des}</div>
								</Card>
				</MediaQuery>
				<MediaQuery minWidth={768}>
				<Card className={`CategoryCard  ${className}`} as={Link} to={`/collection/${category.map_id}`}
							style={{  backgroundImage: `url(/shop/rest/data/images/description/cat${category.map_id}/1?size=large)`, backgroundSize: "cover", backgroundPosition: "center", minWidth: "500px", minHeight: "250px", }}>
								<div className={" white br4 db pa3 mt4 f4 b hover-white underline-hover transition LinkBackgroundStyle"} style={{borderRadius: "15px"}}>{category.desc.short_des}</div>
								</Card>
					</MediaQuery>
				</Fragment>
		}

		if ( !hasParents && fakeParent ) {
			return (
				<MediaQuery maxWidth={767}>
					{(matches) =>
						matches ? (
							<Card className={`CategoryCard searchToken ${className}`} as={Link} to={`/collection/${category.parent}/${category.map_id}`}
							style={{  backgroundImage: `url(/shop/rest/data/images/description/cat${category.map_id}/1?size=medium)`, backgroundSize: "cover", backgroundPosition: "center", minWidth: "500px", minHeight: "250px" }}>
								
								<div className={" white db pa3 mt4 f4 b hover-white underline-hover transition LinkBackgroundStyle "}>{category.desc.short_des}</div>
								</Card>
						) : (
							<Card className={`CategoryCard searchToken ${className}`} as={Link} to={`/collection/${category.parent}/${category.map_id}`}
							style={{  backgroundImage: `url(/shop/rest/data/images/description/cat${category.map_id}/1?size=large)`, backgroundSize: "cover", backgroundPosition: "center", minWidth: "500px", minHeight: "250px" }}>
								<div className={" white db pa3 mt4 f4 b hover-white underline-hover transition LinkBackgroundStyle "}>{category.desc.short_des}</div>
								</Card>
							
						)
					}
				</MediaQuery>
			);
		}

		if ( category.getParents ) {
			//console.log("CategoryCard", category)
			let parents = category.getParents()
			const base = `/collection/${parents.map( id => `${id}/` ).join( "" )}${category.map_id}/`
			return (
				<MediaQuery maxWidth={767}>
					{(matches) =>
						matches ? (
							<Card
							className={`CategoryCard ${className}`}>
								<div className="white pa2 pa3-ns" style={{ backgroundImage: `url("${category.img_src_medium}")`, backgroundSize: "cover", backgroundPosition: "center", minWidth: "500px", minHeight: "350px" }}>
								<Link className={" white db pa3 mt4 f4 b hover-white underline-hover transition LinkBackgroundStyle"} to={base}>{category.desc.short_des}</Link>
								{category.children.map( subcategory => {
									return (
						  <div key={subcategory.map_id}>
							<Link className="pl5 f4  pb2 white-90 db pv1 hover-white underline-hover transition subCatsResp" to={`${base}${subcategory.map_id}`}>{">"} {subcategory.title}</Link>
							{subcategory.children && subcategory.children.length > 0 && (
							  <div className="ml3">
								{subcategory.children.map( childSubcategory => (
								  <Link className="pl5 ml1 f4  white-90 db  pv1 hover-white underline-hover transition subCatsResp" to={`${base}${childSubcategory.map_id}`} key={childSubcategory.map_id}>{">"} {childSubcategory.title}</Link>
								))}
							  </div>
							)}
						  </div>
						);
								})}
							</div>
						</Card>)
						: (
							<Card
							className={`CategoryCard ${className}`}>
								<div className="white pa2 pa3-ns" style={{ backgroundImage: `url("${category.img_src}")`, backgroundSize: "cover", backgroundPosition: "center", minWidth: "500px", minHeight: "350px" }}>
								<Link className={" white db pa3 mt4 f4 b hover-white underline-hover transition LinkBackgroundStyle"} to={base}>{category.desc.short_des}</Link>
								{category.children.map( subcategory => {
									return (
						  <div key={subcategory.map_id}>
							<Link className="pl5 f4  pb2 white-90 db pv1 hover-white underline-hover transition subCatsResp" to={`${base}${subcategory.map_id}`}>{">"} {subcategory.title}</Link>
							{subcategory.children && subcategory.children.length > 0 && (
							  <div className="ml3">
								{subcategory.children.map( childSubcategory => (
								  <Link className="pl5 ml1 f4  white-90 db  pv1 hover-white underline-hover transition subCatsResp" to={`${base}${childSubcategory.map_id}`} key={childSubcategory.map_id}>{">"} {childSubcategory.title}</Link>
								))}
							  </div>
							)}
						  </div>
						);
								})}
							</div>
						</Card>
						)}
				</MediaQuery>
			)
			

		}


		return null
	}
}


// WEBPACK FOOTER //
// ./src/theme/hvz/plugin/CategoryShortcuts/CategoryCard.js